import { render } from "./TabClassProject.vue?vue&type=template&id=71825148"
import script from "./TabClassProject.vue?vue&type=script&lang=js"
export * from "./TabClassProject.vue?vue&type=script&lang=js"

import "./TabClassProject.vue?vue&type=style&index=0&id=71825148&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__